import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ViewHeader = (props)=>{
    const { prev, next, titleAction, data } = props;
    return /*#__PURE__*/ _jsxs("div", {
        className: "navigation-wrapper",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "icon",
                onClick: prev,
                children: "<"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "navigation-title",
                onClick: titleAction,
                children: data
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "icon",
                onClick: next,
                children: ">"
            })
        ]
    });
};
export default ViewHeader;
